import React, { Component } from 'react';
import './styles.css';

class OutputNumberUnitLayout extends Component {
	render() {
		return (
			<div className="output-number-unit-layout">{this.props.children}</div>
		);
	}
}

export default OutputNumberUnitLayout;
